import assert from 'minimalistic-assert'

import { getEthereumStakingInfo, getPolygonStakingInfo } from '../staking/index.js'
import processTxLog from '../tx-log-staking-processor/index.js'

export const createEthereumHooks = ({
  assetClientInterface,
  assetName,
  stakingAssetNames,
  server,
}) => {
  assert(assetClientInterface, 'assetClientInterface is required')
  assert(server, 'server is required')
  assert(assetName, 'assetName is required')
  const afterTickHook = async ({ walletAccount }) => {
    // args passed from monitor tick method ({ monitor, error })
    const assets = await assetClientInterface.getAssetsForNetwork({
      baseAssetName: assetName,
    })

    // some assets may not be available
    const stakingAssets = stakingAssetNames.map((assetName) => assets[assetName]).filter(Boolean)

    const userAddress = await assetClientInterface.getReceiveAddress({
      assetName,
      walletAccount,
      useCache: true,
    })

    const stakingInfo = {
      staking: Object.create(null),
    }

    for (const asset of stakingAssets) {
      const stakingAssetName = asset.name
      const getStakingInfo =
        stakingAssetName === 'polygon' ? getPolygonStakingInfo : getEthereumStakingInfo

      // asset may not be enabled in the wallet
      const assetStakingInfo = await getStakingInfo({
        address: userAddress.toString(),
        asset,
        server,
      })
      stakingInfo.staking[stakingAssetName] = assetStakingInfo
    }

    const batch = assetClientInterface.createOperationsBatch()
    assetClientInterface.updateAccountStateBatch({
      assetName,
      walletAccount,
      newData: stakingInfo,
      batch,
    })

    const processTxLogsPromises = stakingAssets.map((asset) => {
      return processTxLog({
        asset,
        assetClientInterface,
        walletAccount,
        batch,
      })
    })

    await Promise.all(processTxLogsPromises)
    await assetClientInterface.executeOperationsBatch(batch)
  }

  return {
    'after-tick': afterTickHook,
  }
}
